//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportWithAttachments } from './IReportWithAttachments';
import { IReportCashCategoryIDsInputItem } from './IReportCashCategoryIDsInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportEventCategoryIDsInputItem } from './IReportEventCategoryIDsInputItem';
import { IReportFamilyIDsInputItem } from './IReportFamilyIDsInputItem';
import { RevenueAndExpenseReportBasis, RevenueAndExpenseReportDetailLevel, RevenueAndExpenseReportSortBy, ReportType } from './Enums';

export class RevenueAndExpenseReportInputItem extends ReportInputItem implements IReportWithAttachments, IReportCashCategoryIDsInputItem, IReportDateRangeInputItem, IReportEventCategoryIDsInputItem, IReportFamilyIDsInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    EventCategoryIDs: string[] = [];
    Basis: RevenueAndExpenseReportBasis = RevenueAndExpenseReportBasis.Accrual;
    DetailLevel: RevenueAndExpenseReportDetailLevel = RevenueAndExpenseReportDetailLevel.Itemized;
    SortBy: RevenueAndExpenseReportSortBy = RevenueAndExpenseReportSortBy.Category;
    IncludeAttachments: boolean = false;
    PayeeNames: string[] = [];
    FamilyIDs: string[] = [];
    CashCategoryIDs: string[] = [];
    override readonly Type: ReportType = ReportType.IncomeExpenseReport;

    constructor(initializer?: Partial<Omit<RevenueAndExpenseReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "RevenueAndExpenseReportInputItem";
}
